import InputCodeDonor from './InputCodeDonor.vue'

export { InputCodeDonor }
